<template>
  <div class="acomodar"> 
    <div class="d-flex">

      <button class="btn btn-danger ms-2 my-2" @click="$router.push('/gestionSolicitudes')">
        <i class="bi bi-skip-backward"></i>
      </button>

      <button :disabled="botonCambioRq" class="btn btn-success ms-2 my-2" @click="editarDatoSolicitud" v-if="
        (permisoVisualizador == 2 ||
          permisoVisualizador == 10 ||
          permisoVisualizador == 18) &&
        prender
      " title="MODIFICAR SOLICITUD">
        <i class="bi bi-pencil-square"></i>
      </button>

      <div class="my-2 ms-2">
        <b-button v-b-modal.modal-center class="bg-success" title="ASIGNAR PERSONAL DE SELECCION">
          <i class="bi bi-person-workspace"></i></b-button>

        <b-modal id="modal-center" centered title="ASIGNAR PERSONAL DE SELECCION">
          <div class="d-flex mt-2">
            <select class="form-control my-auto" @change="ModificarTrabajador($event)">
              <option selected>--ESCOGER AL ENTREVISTADOR--</option>
              <option v-for="ide in responsable" :key="ide.id" :value="ide.idTrabajador">
                {{ ide.nombreTrabajador }}
              </option>
            </select>
            <button :disabled="negado2" class="btn btn-success mx-2 my-auto" @click="getAttributesPut">
              <i class="bi bi-floppy"></i>
            </button>
          </div>
          <div></div>
        </b-modal>
      </div>

      <div class="my-2 ms-2">
        <b-button v-b-modal.modal-center1 class="bg-success" title="CAMBIAR ESTADO DE SOLICITUD">
          <i class="bi bi-file-earmark-x"></i></b-button>

        <b-modal id="modal-center1" centered title="CAMBIAR ESTADO DE SOLICITUD">
          <div class="d-flex">
            <select class="form-control" @change="ModificarEstado($event)">
              <option>--SELECCIONAR ESTADO--</option>
              <!-- v-for="estados in info" :key="estados.id"  -->
              <option v-for="estados in info.slice(2, 4)" :key="estados.id" :value="estados.parCorrelativo">
                {{ estados.parDescripcion }}
              </option>
            </select>
            <button class="btn btn-success ms-2 my-auto" :disabled="negado" @click="getAttributesEstado">
              <i class="bi bi-floppy"></i>
            </button>
          </div>
        </b-modal>
      </div>
    </div>

    <!-- <button class="btn btn-secondary mx-4 my-2" @click="base">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        class="bi bi-database-add"
        viewBox="0 0 16 16"
      >
        <path
          d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
        />
        <path
          d="M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
        />
      </svg>
      AGREGAR POSTULANTE DE BASE DE DATOS
    </button> -->
    <div class="mx-2">
      <div class="col-12">
        <div class="border border-1 rounded-3 px-3 py-2 mb-2 bg-white shadow-sm 
              d-flex justify-content-between align-items-center flex-wrap">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-journal-text display-5 text-primary"></i>
            <div class="lh-sm">
              <p class="mb-1 reducirTamaño text-secondary fw-semibold text-uppercase">
                GESTION DE SOLICITUDES
              </p>
              <p class="mb-0 tituloResaltado fs-5 fw-bold">DATOS DE LA SOLICITUD:</p>
            </div>
          </div>
          <div class="text-end my-auto">
            <i class="bi bi-chevron-down fs-5" @click="ocultar = !ocultar"></i>
          </div>
        </div>
      </div>


      <div class="col-12">
        <div v-if="ocultar" class="tamaño row g-2 mb-2">

          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 letrasTitulos" style="font-size: 1.16rem">
              <label class="ms-2" disabled style="font-weight: 700">
                <strong>{{ CanPostulante }}</strong> {{ NomPuesto }}</label>
            </div>
          </div>

          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 letrasTitulos"
              style="font-size: 1.16rem; font-weight: 700">
              <label class="ms-2" disabled>
                {{ DesDepartamento }} - {{ DesProvincia }} -
                {{ DesDistrito }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 text-end">
              <label class="text-danger ms-1" style="font-weight: 800" :class="{
                'text-danger ': FecPresentacion.slice(7, 11) == '1900',
              }">DEADLINE:</label>
              <label style="font-weight: 800" v-if="
                FecPresentacion.slice(7, 11) != '1900'
                  ? (cerrarPostulante = true)
                  : (cerrarPostulante = false)
              " class="ms-1" disabled>
                {{ FecPresentacion }}
              </label>

              <label style="font-weight: 800" :class="{ 'text-danger': FecPresentacion.slice(7, 11) == '1900' }"
                v-if="FecPresentacion.slice(7, 11) == '1900'" class="ms-1" disabled>
                -</label>

              <div class="text-dark">
                <label class="" disabled> {{ nomSelAsignado }}</label>
              </div>

              <div class="">
                <label style="font-weight: 800" class="text-primary" disabled>
                  {{ desSolEstado }}</label>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row g-2">

              <p class="mb-0 tamaño">
                REQUERIMIENTO SOLICITADO EL
                <label style="font-weight: 700">{{ FecRegistro }} </label>
                (LA FECHA ESTIMADA DE ENTREGA ES EL
                <label class="" style="font-weight: 700">{{ FecFinEstimada }}</label>)
              </p>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 ps-2 pintar">SERVICIO :</p>
                  <label class="tamaño ps-2" disabled>
                    {{
                      idEmpresaRq == 1
                        ? 'SELECCION'
                        : [2, 3].includes(idEmpresaRq)
                          ? 'OUTSOURCING'
                          : 'INTERMEDIACIÓN'
                    }}
                  </label>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 ps-2 pintar">PROYECTO:</p>
                  <label class="tamaño ps-2" disabled>
                    <!-- {{ NomEmpresa }} | {{ CentroCosto }} | -->
                    {{ SubCentroCosto }} |
                    {{ SubSubCentroCosto }}
                  </label>
                </div>
              </div>


              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">SOLICITANTE:</p>
                  <label class="" disabled> {{ NomTrabajador }}</label>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">MOTIVO:</p>
                  <p class="mb-0" disabled>{{ DesMotivo }}</p>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">LUGAR DE TRABAJO:</p>
                  <label class="" disabled> {{ LugarTrabajo }}</label>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">HORARIO DE TRABAJO:</p>
                  <label class="" disabled> {{ HorTrabajo }}</label>
                </div>
              </div>


              <!-- <div class="col-12 col-md-1">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0  pintar">TIPO DE CONTRATO:</p>
                  <label class="" disabled> {{ DesTipContrato }}</label>
                </div>
              </div> -->

              <div class="col-12 col-md-12">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 ms-2 pintar">DETALLE:</p>
                  <label class="ms-2" disabled> {{ DesExtra }}</label>
                </div>
              </div>


              <!-- ICONO -->

              <div class="col-12 " v-if="
                permisoVisualizador == 2 ||
                permisoVisualizador == 6 ||
                permisoVisualizador == 8 ||
                (permisoVisualizador == 18 && codigoCentro != '02')
              ">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">
                  <div class="d-flex flex-wrap justify-content-around text-center">
                    <div class="mx-3">
                      <i class="bi bi-calendar3 fs-4"></i>

                      <p class="color mb-0">{{ DesOpoPago }}</p>
                      <p class="tamaño mb-0" disabled>Oportunidad de Pago</p>
                    </div>

                    <div v-if="SueldoMensual > 0" class="mx-3">
                      <i class="bi bi-cash-stack fs-4"></i>
                      <p class="color mb-0">{{ SueldoMensual }}</p>
                      <p class="mb-0 tamaño" disabled>Sueldo básico(RBM)</p>
                    </div>

                    <div v-if="SueldoDiario > 0" class="mx-3">
                      <i class="bi bi-coin fs-4"></i>
                      <p class="color mb-0">{{ SueldoDiario }}</p>
                      <p class="tamaño" disabled>Sueldo básico(RBD)</p>
                    </div>

                    <div v-if="MonAlimientacion > 0" class="mx-3">
                      <i class="bi bi-cup-hot fs-4"></i>
                      <p class="color mb-0">{{ MonAlimientacion }}</p>
                      <p class="tamaño" disabled>Alimentación</p>
                    </div>

                    <div v-if="MonMovilidad > 0" class="mx-3">
                      <i class="bi bi-car-front-fill fs-4"></i>
                      <p class="color mb-0">{{ MonMovilidad }}</p>
                      <p class="tamaño" disabled>Movilidad</p>
                    </div>

                    <div v-if="MonVariable > 0" class="mx-3">
                      <i class="bi bi-wallet2 fs-4"></i>
                      <p class="color mb-0">{{ MonVariable }}</p>
                      <p class="tamaño" disabled>Variable</p>
                    </div>

                    <div v-if="MonViatico > 0" class="mx-3">
                      <i class="bi bi-luggage fs-4"></i>

                      <p class="color mb-0">{{ MonViatico }}</p>
                      <p class="tamaño" disabled>Viáticos</p>
                    </div>

                    <div v-if="HoraExtra > 0" class="mx-3">
                      <i class="bi bi-hourglass-top fs-4"></i>
                      <p class="color mb-0">{{ HoraExtra }}</p>
                      <p class="tamaño" disabled>Hrs Extra</p>
                    </div>

                    <div v-if="DiasDescanso > 0" class="mx-3">
                      <i class="bi bi-calendar-event fs-4"></i>
                      <p class="color mb-0">{{ DiasDescanso }}</p>
                      <p class="tamaño" disabled>Descanso(Días)</p>
                    </div>

                    <div v-if="MonOtro > 0" class="mx-3">
                      <i class="bi bi-file-plus fs-4"></i>
                      <p class="color mb-0">{{ MonOtro }}</p>
                      <p class="tamaño" disabled>Otros</p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="
                IndVacuna ||
                IndCarnet ||
                IndVulnerabilidad ||
                indJudiciales ||
                indPoliciales ||
                indPenales ||
                indSanidad ||
                indCertijoven
              " class="col-12 col-md-3 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- ICONO IZQUIERDA -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-check fs-2 text-success"></i>
                  </div>

                  <!-- CHECKBOXES DERECHA -->
                  <div class="flex-grow-1">
                    <div v-if="IndVacuna" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndVacuna" />
                      <label class="form-check-label">CARNET DE VACUNACION</label>
                    </div>

                    <div v-if="IndCarnet" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndCarnet" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="IndVulnerabilidad" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="IndVulnerabilidad" />
                      <label class="form-check-label">DECLARACION JURADA DE VULNERABILIDAD</label>
                    </div>

                    <div v-if="indJudiciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indJudiciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES JUDICIALES</label>
                    </div>

                    <div v-if="indPoliciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPoliciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES POLICIALES</label>
                    </div>

                    <div v-if="indPenales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPenales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES PENALES</label>
                    </div>

                    <div v-if="indSanidad" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indSanidad" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="indCertijoven" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="indCertijoven" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES O CERTIJOVEN</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="IndEmpo || IndCovid" class="col-12 col-md-3 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <div class="mx-3 text-center my-auto">
                    <i class="bi bi-clipboard-heart fs-2 text-danger"></i>
                  </div>
                  <div class="">
                    <div v-if="IndEmpo" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndEmpo" />
                      <label class="form-check-label" for="flexCheckDefault">
                        EXAMEN MEDICO PRE-OCUPACIONAL(EMPO)
                      </label>
                    </div>
                    <div v-if="IndCovid" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndCovid" />
                      <label class="form-check-label" for="flexCheckDefault">
                        PRUEBA COVID
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- Icono centrado -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-data fs-2 text-primary"></i>
                  </div>

                  <!-- Opciones compactas -->
                  <div class="d-flex flex-wrap flex-grow-1">
                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solDisViaje" />
                      <label class="form-check-label">DISPONIBILIDAD DE VIAJE</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovPropio" />
                      <label class="form-check-label">USO DE MOVIL PROPIO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solAplicativo" />
                      <label class="form-check-label">USO DE APLICATIVOS</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solEpps" />
                      <label class="form-check-label">USO DE EPPs</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solUniforme" />
                      <label class="form-check-label">USO DE UNIFORME</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovil" />
                      <label class="form-check-label">USO DE MOVIL CORPORATIVO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solLaptop" />
                      <label class="form-check-label">USO DE LAPTOP CORPORATIVA</label>
                    </div>
                  </div>
                </div>
              </div>


              <div v-if="rutaPerfil != '0'" class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
                  
                  <p class="mt-2 text-center mb-0 align-self-center">FORMATO DE PERFIL DEL PUESTO </p>
                  <a  :href="url.slice(0, 49) + rutaPerfil.slice(42)" target="_blank">
                    <button class="btn btn-primary text-white boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </button>
                  </a>
                </div>
              </div>

              <div v-if="Adjunto != 1" class="col-12 col-md-4">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
                  <div class="my-auto text-center">
                    <a :href="url + Adjunto.slice(52, Adjunto.length)" target="_blank" class="align-self-center">
                      <i class="bi bi-file-earmark-arrow-down fs-2"></i>
                    </a>
                    <!-- <p class="text-center mb-0 align-self-center" v-if="Adjunto == 1">
                SIN ADJUNTO
              </p> -->
                    <p class="text-center mb-0 align-self-center">
                      {{ Adjunto.slice(52, Adjunto.length) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- tabla1 -->

    <div>
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-content-end align-items-center">
              <label class="mt-4 me-2"></label>

              <div class="input-group w-25 mt-3">
                <span class="input-group-text bg-white">
                  <i class="bi bi-search"></i>
                </span>
                <input type="text" class="form-control form-control-lg" placeholder="Búsqueda por nombres..."
                  v-model="dni_busqueda" />
              </div>
            </div>

            <div class="mt-2 ms-2 tamaño">
              (*) Solo escoger el estado de
              <strong class="text-success"> SELECCIONADO </strong> cuando estén
              terminadas todas las etapas de:<strong>
                Selección, Entrevista, Documentos y Capacitación.
              </strong>
            </div>
            <div class="table-responsive mt-2 mx-2">
              <div v-if="Tabla1">
                <table v-if="dni_busqueda.length <= 0 ? cerrarTable1 : !cerrarTable1"
                  class="table table-bordered tamañoLetra">
                  <thead>
                    <tr class="bg-solimano text-center text-white">
                      <th colspan="4"></th>
                      <th colspan="2">SELECCION</th>
                      <th colspan="2">ENTREVISTA</th>
                      <th colspan="2">DOCUMENTO</th>
                      <th colspan="2">CAPACITACION</th>
                      <th colspan="2">CONTRATOS</th>

                      <th colspan="5"></th>
                    </tr>
                    <tr class="bg-solimano text-center text-white">
                      <th scope="col">N° RQ</th>
                      <th scope="col">REF.</th>
                      <th scope="col">POSTULANTE</th>
                      <th scope="col">ESTADO</th>

                      <th selector scope="col">ETAPA</th>

                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <!-- <th
                        v-if="permisoVisualizador != 2"
                        scope="col"
                        class="text-nowrap px-5"
                      >
                        OBSERVACION POSTULANTE
                      </th>
                      <th
                        v-if="permisoVisualizador == 2"
                        scope="col"
                        class="text-nowrap px-5"
                      >
                        ESTADO DEL POSTULANTE (*)
                      </th> -->
                      <th scope="col">
                        <i class="bi bi-boxes fs-5"></i>
                      </th>
                      <!-- <th scope="col" class="text-nowrap px-5">DETALLE</th>
                      <th scope="col">ACCION</th> -->
                      <th scope="col" v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        FEC.INIC.CONTRATO
                      </th>
                      <th scope="col" v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        FEC.FIN.CONTRATO
                      </th>
                      <!-- <th scope="col" v-if="permisoVisualizador == 6">
                      ACCION
                    </th> -->
                    </tr>
                  </thead>
                  <tbody v-for="post in paginatedInfo" :key="post.idSolxPostulante"
                    class="text-nowrap text-center align-middle">
                    <tr class="text-center" v-if="dni_busqueda.length < 1 ? true : false">
                      <th scope="row">{{ post.idMaeSolicitud }}</th>
                      <td class="text-center"> <!-- <button :disabled="permisoVisualizador == 2 ||
                          permisoVisualizador == 18
                          ? false
                          : true
                          " class="btn py-1 my-0 border-0">
                          <i class="bi bi-star-fill" @click="cambiarReferido(post.idSolxPostulante)" :class="{
                            'text-warning ': post.solReferido,
                            'text-secondary ': !post.solReferido,
                          }"></i>
                        </button> -->
                        <div class="referido">
                          <select v-if="
                            permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                          " class="form-control text-secondary text-center tamaño w-100 py-1 my-0" @change="
                            cambiarReferido(
                              post.idSolxPostulante,
                              $event.target.value
                            )
                            ">
                            <option v-if="post.solDesMotivo != null" selected disabled value="">
                              {{ post.solfuente }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="referencia in referido" :key="referencia.idParametro"
                              :value="referencia.parCorrelativo">
                              <button class="btn btn-succes">ss</button> {{ referencia.parDescripcion }}
                            </option>
                          </select>
                        </div>

                      </td>

                      <td class="">
                        <span class="text-danger mx-2" v-if="
                          post.nombre.slice(0, 21) == '[FALTA CREAR USUARIO]'
                        ">
                          {{ post.nombre.slice(0, 21) }}
                        </span>
                        <span v-if="
                          post.nombre.slice(0, 21) == '[FALTA CREAR USUARIO]'
                        ">
                          {{ post.nombre.slice(21, post.nombre.length) }}
                        </span>
                        <span v-else>{{ post.nombre }}</span>
                      </td>

                      <td class="text-nowrap text-center align-middle">
                        <div class="agrandar">
                          <!-- {{ post.solDesMotivo }} -->
                          <select v-if="
                            permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                          " class="form-control text-secondary tamaño w-100 py-1 my-0" @change="
                            comenta(
                              $event,
                              post.idSolxPostulante,
                              post.solPosMotivo,
                              post.solComentario
                            )
                            "
                             :disabled="post.solPosContratos">
                            <option v-if="post.solDesMotivo != null" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>
                            <!--  -->
                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                              <option v-show="coment.parCorrelativo !== '010' || (post.solPosSeleccion == 1 && post.solPosEntrevista == 1 && post.solPosDocumento == 1 && post.solPosCapacitacion == 1 )"  v-for="coment in comentarios.slice(0, 7)" :key="coment.id"
                              :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }} 
                            </option>
                          </select>

                          <select v-if="permisoVisualizador == 10" :disabled="post.solPosMotivo == '010'" class="form-control tamaño py-1 my-0 text-secondary"
                            @change="
                              comenta(
                                $event,
                                post.idSolxPostulante,
                                post.solPosMotivo,
                                post.solComentario
                              )
                              ">
                            <option v-if="post.solDesMotivo != ''" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="coment in comentarios.slice(7, 11)" :key="coment.id"
                              :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }}
                            </option>
                          </select>

                          <select v-if="permisoVisualizador == 9" :disabled="post.solPosMotivo == '010'"
                            class="form-control tamaño py-1 my-0 text-center text-secondary" @change="
                              comenta(
                                $event,
                                post.idSolxPostulante,
                                post.solPosMotivo,
                                post.solComentario
                              )
                              ">
                            <option v-if="post.solDesMotivo != ''" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="coment in comentarios.slice(
                              11,
                              comentarios.length
                            )" :key="coment.id" :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }}
                            </option>
                          </select>
                        </div>
                        <span v-if="permisoVisualizador == 6" :class="{
                          'text-success': post.solPosMotivo == '010',
                          'text-danger':
                            post.solPosMotivo != '010' &&
                            post.solPosMotivo != '011',
                          'text-primary ': post.solPosMotivo == '011',
                          'text-primary ': post.solPosMotivo == '005',
                        }" class="tamaño">
                          {{ post.solDesMotivo }}</span>
                      </td>

                      <td>
                        <button @click="editSeleccion(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosSeleccion,
                          'btn btn-success py-1 my-0': post.solPosSeleccion,
                        }">
                          <i v-if="post.solPosSeleccion" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosSeleccion" class="bi bi-person-bounding-box"></i>
                        </button>
                      </td>

                      <td class="text-center" v-if="post.solFecSelEjec.slice(0, 4) == 1900">
                        --
                      </td>
                      <td v-else>{{ post.solFecSelEjec.slice(0, 10) }}</td>

                      <td>
                        <button @click="editEntrevista(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosEntrevista,
                          'btn btn-success py-1 my-0': post.solPosEntrevista,
                        }">
                          <i v-if="post.solPosEntrevista" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosEntrevista" class="bi bi-headset"></i>
                        </button>
                      </td>

                      <td class="text-center" v-if="post.solFecEntEjec.slice(0, 4) == 1900">
                        --
                      </td>
                      <td v-else>{{ post.solFecEntEjec.slice(0, 10) }}</td>

                      <td>
                        <button @click="editDocumentos(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosDocumento,
                          'btn btn-success py-1 my-0': post.solPosDocumento,
                        }">
                          <i v-if="post.solPosDocumento" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosDocumento" class="bi bi-folder2-open"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecDocEjec.slice(0, 4) == 1900">--</td>
                      <td v-else>{{ post.solFecDocEjec.slice(0, 10) }}</td>

                     
                     


                       <td>
                        <button @click="editCapacitaciones(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0':
                            !post.solPosCapacitacion,
                          'btn btn-success py-1 my-0':
                            post.solPosCapacitacion,
                        }">
                          <i v-if="post.solPosCapacitacion" class="bi bi-check-circle"></i>
                          <i v-if="!post.solPosCapacitacion" class="bi bi-camera-reels"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecCapEjec.slice(0, 4) == 1900"></td>
                      <td v-else>{{ post.solFecCapEjec.slice(0, 10) }}</td>

                       <td>
                        <button @click="editContrato(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosContratos,
                          'btn btn-success py-1 my-0': post.solPosContratos,
                        }">
                          <i v-if="post.solPosContratos" class="bi bi-check-circle"></i>
                          <i v-if="!post.solPosContratos" class="bi bi-vector-pen"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecConEjec.slice(0, 4) == 1900">--</td>
                      <td v-if="post.solFecConEjec.slice(0, 4) != 1900">
                        {{ post.solFecConEjec.slice(0, 10) }}
                      </td>

                      <!-- <td v-else>
                      <b-form-input
                        class="my-1"
                        placeholder="Comenta..." disabled v-model="post.solComentario"></b-form-input>
                    </td> -->

                      <td class="d-flex">
                        <b-button v-b-modal.modal-center5 @click="
                          () => {
                            idPostulante = post.idSolxPostulante;
                            solPosMotivo = post.solPosMotivo;
                            comentario = post.solComentario;
                            CargaObservaciones();
                          }
                        " :class="{
                          'btn btn-light border border-1':
                            post.solComentario == '',
                          'btn btn-danger': post.solComentario != '',
                        }">
                          <i class="bi bi-chat-dots"></i>
                        </b-button>

                        <button @click="
                          CrearUser(
                            post.idMaePostulante,
                            post.nombre.slice(21, post.nombre.length),
                            post.posNroDocumento,
                            post.idSolxPostulante
                          )
                          " :disabled="permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                            ? false
                            : true
                            " class="btn btn-light border border-1 py-1 my-0 ms-2">
                          <i class="bi bi-person-add"></i>
                        </button>

                        <!-- <button
                          class="btn btn-success ms-2 py-1 my-0"
                          @click="
                            mandarComentarios(
                              post.idSolxPostulante,
                              post.solPosMotivo,
                              post.solComentario
                            )
                          "
                        >
                          <i class="bi bi-floppy"></i>
                        </button> -->
                        <button v-if="
                          permisoVisualizador == 2 ||
                          permisoVisualizador == 18
                        " class="btn btn-light ms-2 border border-1 py-1 my-0"
                          @click="mandarEstadoPostulanteXcorreo(post)">
                          <i class="bi bi-envelope-at"></i>
                        </button>
                      </td>

                      <td v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        <input type="date" class="form-control" aria-describedby="emailHelp"
                          v-model="post.fecIniContrato" @change="datosIni(post)" />
                      </td>

                      <td v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        <input type="date" class="form-control" aria-describedby="emailHelp"
                          v-model="post.fecFinContrato" @change="datosFin(post)" />
                      </td>
                      <!-- <td v-if="permisoVisualizador == 6">
                      <button class="btn btn-primary" @click="actualizarFec(post.idSolxPostulante)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-save"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
                          />
                        </svg>
                      </button>
                    </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>

              <b-modal size="lg" id="modal-center5" centered title="COMENTARIOS" body-class="custom-modal-body"
                hide-footer>
                <div class="d-flex w-100 h mt-2">
                  <b-form-textarea v-if="permisoVisualizador == 10 || permisoVisualizador == 2" class="pt-4 my-0"
                    v-model="insertarComentario"></b-form-textarea>

                  <b-form-textarea v-else class="my-0 py-1" disabled v-model="comentario">
                  </b-form-textarea>
                  <button v-if="permisoVisualizador == 10 || permisoVisualizador == 2"
                    class="btn btn-success my-auto ms-2" @click="
                      mandarComentarios(
                        idPostulante,
                        solPosMotivo,
                        insertarComentario
                      )
                      ">
                    <i class="bi bi-floppy"></i>
                  </button>
                </div>

                <div class="mt-2">
                  <strong>Comentarios anteriores</strong>
                </div>
                <div class="d-flex w-100 mt-2">
                  <b-form-textarea class="pt-4" disabled rows="10" :value="observaciones
                    .map((o) => `${o.fecEstado} -- ${o.obsComentario}`)
                    .join('\n')
                    "></b-form-textarea>
                </div>
              </b-modal>

              <!-- tabla2 -->

              <div v-if="
                dni_busqueda.length === 2 || dni_busqueda.length === 1
                  ? true
                  : false
              " class="text-center container overflow-hidden mt-5">
                <b-spinner variant="primary"></b-spinner>
                buscado .......
              </div>
            </div>

            <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
              <!-- Primera página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>

              <!-- Retroceder -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>

              <!-- Página actual -->
              <span class="pagination-info fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>

              <!-- Avanzar -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>

              <!-- Última página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  name: "SolimanologGestionDeSolicitudes",

  data() {
    return {
      idPostulante: "",
      solPosMotivo: "",
      comentario: "",
      amigo: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Solicitud/",
      negado: true,
      negado2: true,

      IdSolicitud: "",
      FecRegistro: "",
      FecFinEstimada: "",
      FecPresentacion: "",
      NomPuesto: "",
      CanPostulante: "",
      NomEmpresa: "",
      CentroCosto: "",
      SubCentroCosto: "",
      SubSubCentroCosto: "",
      DesDepartamento: "",
      DesDistrito: "",
      DesProvincia: "",
      nomSelAsignado: "",
      NomTrabajador: "",
      CargoBoleta: "",
      DesMotivo: "",
      DesExtra: "",
      DetalleMotivo: "",
      desSolEstado: "",
      LugarTrabajo: "",
      HorTrabajo: "",
      DesTipContrato: "",
      DiasDescanso: "",
      SueldoMensual: "",
      SueldoDiario: "",
      MonVariable: "",
      MonAlimientacion: "",
      MonMovilidad: "",
      HoraExtra: "",
      MonViatico: "",
      MonOtro: "",
      DesOpoPago: "",
      IndVacuna: "",
      IndCarnet: "",
      IndVulnerabilidad: "",
      IndEmpo: "",
      IndCovid: "",
      Adjunto: "",
      indJudiciales: Boolean,
      indPoliciales: Boolean,
      indPenales: Boolean,
      indSanidad: Boolean,
      indCertijoven: Boolean,

      //otra api
      info: [],
      postulantes: [],

      prender: false,
      campaña: "",
      //tercera api
      responsable: [],

      botonCambioRq: true,

      mandarPut: {
        idSolicitud: "",
        idSelAsignado: "",
      },

      codSolEstado: "",
      nombreDelUsuario: "",

      // tabla


      forms: {
        IdSolxPostulante: "",
        FecIniContratos: "",
        FecFinContratos: "",
        idUsuario: "",
      },
      numeroDocumento: "",

      form: {
        solComentario: "",
      },

      informacion: [],
      dni_busqueda: "",
      comentarioCorrela: "",
      comentarios: [],
      acomodar: "",
      acomodare: "",
      retro: false,
      cerrar: true,
      cerrar2: true,
      cerrarTable1: true,
      cerrarTable2: false,
      Tabla1: true,
      adams: false,
      avanzar: true,
      currentPage: 1,
      itemsPerPage: 4,
      permisoVisualizador: null,
      ocultar: true,
      observaciones: [],
      insertarComentario: "",
      referido: [],
      codigoCentro: "",
      idEmpresaRq: "",
      solDisViaje: false,
      solMovPropio: false,
      solAplicativo: false,
      solEpps: false,
      solUniforme: false,
      solMovil: false,
      solLaptop: false,
      rutaPerfil: ''


    };
  },
  async mounted() {
    this.parametro = this.$route.params.postulante;
    let parametros = localStorage.getItem("solicitudXpostulante");
    this.forms.idUsuario = localStorage.getItem("userId");

    this.permisoVisualizador = localStorage.getItem("idPerfil");

    const api3 = this.axios.get("JerarquiaTrabajadorData/Jerarquia/4");
    let r = await api3;
    this.responsable = r.data;
    console.log(r.data);

    const api2 = this.axios.get("ParametroData/Parametro/59");
    let res = await api2;
    this.info = res.data;
    this.mandarPut.idSolicitud = this.$route.params.postulante;
    this.axios.get("ParametroData/Parametro/7729").then(r => {
      this.referido = r.data
    })
    const respuesta = await this.axios.get(
      "SolicitudPostulante/ObtenerPosxSol/" + parametros
    );
    this.postulantes = respuesta.data;
    console.log(this.postulantes);

    this.botonCambioRq = this.postulantes.some(
      (objeto) => objeto.solPosMotivo == "010"
    )
      ? true
      : false;

    const api = this.axios.get(
      "SolicitudData/Obtener/" + this.mandarPut.idSolicitud
    );
    let response = await api;
    this.prender = true;

    console.log(response);
    this.IdSolicitud = response.data[0].idSolicitud;
    this.FecRegistro = response.data[0].fecRegistro;
    this.FecFinEstimada = response.data[0].fecSolFinal;
    this.FecPresentacion = response.data[0].fecPresentacion;
    this.NomPuesto = response.data[0].nomPuesto;
    this.CanPostulante = response.data[0].canPostulante;
    this.NomEmpresa = response.data[0].nomEmpresa;
    this.CentroCosto = response.data[0].centroCosto;
    this.SubCentroCosto = response.data[0].subCentroCosto;
    this.SubSubCentroCosto = response.data[0].subSubCentroCosto;
    this.DesDepartamento = response.data[0].desDepartamento;
    this.NomTrabajador = response.data[0].nomTrabajador;
    this.CargoBoleta = response.data[0].cargoBoleta;
    this.DesMotivo = response.data[0].desMotivo;
    this.DesExtra = response.data[0].desExtra;
    this.DetalleMotivo = response.data[0].detalleMotivo;
    this.LugarTrabajo = response.data[0].lugarTrabajo;
    this.HorTrabajo = response.data[0].horTrabajo;
    this.DesTipContrato = response.data[0].desTipContrato;
    this.DiasDescanso = response.data[0].diasDescanso;
    this.SueldoMensual = response.data[0].sueldoMensual;
    this.SueldoDiario = response.data[0].sueldoDiario;
    this.MonVariable = response.data[0].monVariable;
    this.MonAlimientacion = response.data[0].monAlimentacion;
    this.MonMovilidad = response.data[0].monMovilidad;
    this.HoraExtra = response.data[0].horaExtra;
    this.MonViatico = response.data[0].monViatico;
    this.MonOtro = response.data[0].monOtro;
    this.DesOpoPago = response.data[0].desOpoPago;
    this.desSolEstado = response.data[0].desSolEstado;
    this.nomSelAsignado = response.data[0].nomSelAsignado;
    this.IndVacuna = response.data[0].indVacuna;
    this.IndCarnet = response.data[0].indCarnet;
    this.IndVulnerabilidad = response.data[0].indVulnerabilidad;
    this.IndEmpo = response.data[0].indEmpo;
    this.IndCovid = response.data[0].indCovid;
    this.Adjunto = response.data[0].adjunto;
    this.DesDistrito = response.data[0].desDistrito;
    this.DesProvincia = response.data[0].desProvincia;
    this.indJudiciales = response.data[0].indJudiciales;
    this.indPoliciales = response.data[0].indPoliciales;
    this.indPenales = response.data[0].indPenales;
    this.indSanidad = response.data[0].indSanidad;
    this.indCertijoven = response.data[0].indCertiJoven;

    this.codigoCentro = response.data[0].codCentro
    this.idEmpresaRq = response.data[0].idEmpresa

    this.solDisViaje = response.data[0].solDisviaje
    this.solMovPropio = response.data[0].solMovpropio
    this.solAplicativo = response.data[0].solAplicativo
    this.solEpps = response.data[0].usoSolEPPs
    this.solUniforme = response.data[0].usoSolUniforme
    this.solMovil = response.data[0].usoSolMovilCoporativo
    this.solLaptop = response.data[0].usoSolLaptop
    this.rutaPerfil = response.data[0].rutaPerfil

    //segunda api
    this.campaña = response.data[0].campana;

    this.axios
      .get("SolicitudData/Obtener/" + this.$route.params.postulante)
      .then((r) => {
        console.log(r.data);
        this.idSelAsignado = r.data[0].idSelAsignado;
        this.idTrabajador = r.data[0].idTrabajador;
        this.ObtenerCorreos(this.idSelAsignado, this.idTrabajador);
      });

    let responses = await this.axios.get(
      "SolicitudPostulante/ObtenerPosxSol/" + parametros
    );
    console.log(responses.data);
    this.informacion = responses.data;

    for (let index of this.informacion) {
      if (
        index.solPosSeleccion == true &&
        index.solPosEntrevista == true &&
        index.solPosDocumento == true &&
        index.solPosContratos == true &&
        index.solPosCapacitacion == true &&
        index.solNotContrato == false &&
        index.fecIniContrato > "2023-02-09"
      ) {
        console.log(index);
        this.axios
          .post(
            `Values/CorreoProcesoSel?correoUsuario=${this.correoUno
            }&correoUsuario2=${this.correoDos}&Nombre=${index.nombre.slice(
              9,
              index.nombre.length
            )}&FechaInicio=${index.fecIniContrato}&idSolicitud=${this.$route.params.ide
            }&apePaterno=${index.nombre.slice(9, index.nombre.length)}`
          )
          .then((r) => {
            console.log(r.data);
            if (r.data == true) {
              this.ModificarEstadoContra(index.idSolxPostulante);
            }
          });
      }
    }

    let comentario = await this.axios.get("ParametroData/Parametro/7507");
    this.comentarios = comentario.data;
  },

  created() {
    this.cambiarEstadoNavbar();
  },

  computed: {

    comentariosFiltrados() {
      // Filtra los comentarios basados en algún criterio
      // En este ejemplo, excluiremos los elementos con parCorrelativo "elemento_no_deseado"
      return this.comentarios
        .slice(5, this.comentarios.length - 1)
        .filter((coment) => coment.parCorrelativo !== "031");
    },
    filteredInfo() {
      if (this.dni_busqueda.length < 3) return this.informacion;

      return this.informacion.filter(post =>
        post.nombre.toLowerCase().includes(this.dni_busqueda.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.filteredInfo.length / this.itemsPerPage);
    },

    paginatedInfo() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredInfo.slice(start, start + this.itemsPerPage);
    },
  },

  methods: {
    ...mapActions("solicitudesListado", ["getAttributs"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    async getAttributes() {
      let parametro = localStorage.getItem("solicitudXpostulante");

      let response = await this.axios.get(
        "SolicitudPostulante/ObtenerPosxSol/" + parametro
      );

      this.informacion = response.data;
      console.log(this.informacion)

      this.botonCambioRq = this.informacion.some(
        (objeto) => objeto.solPosMotivo == "010"
      )
        ? true
        : false;
    },

    CargaObservaciones() {
      this.axios
        .get(`SolicitudPostulante/ObtenerPosxSolEstado/${this.idPostulante}`)
        .then((r) => {
          this.observaciones = r.data;
          console.log("aqui es la respuesta", r.data);
        });
    },

    ModificarEstadoContra(idSolxPostulante) {
      let solNotContrato = true;

      this.axios.put(`SolicitudPostulante/ModificarCorreoContrato`, {
        idSolxPostulante,
        solNotContrato,
      });
    },

    ObtenerCorreos(correo1, correo2) {
      console.log(correo2);
      this.axios.get(`Values/Obtener/${correo1}`).then((r) => {
        console.log(r.data[0].correo);
        this.correoUno = r.data[0].correo;
      });

      this.axios.get(`Values/Obtener/${correo2}`).then((r) => {
        console.log(r.data[0].correo);
        this.correoDos = r.data[0].correo;
      });
    },

    mandarEstadoPostulanteXcorreo(items) {
      this.getAttributes();
      console.log(this.correoUno, this.correoDos);
      this.axios
        .post(
          `Values/CorreoPos?correoUsuario=${this.correoUno}&correoUsuario2=${this.correoDos
          }&estadoPostulante=${items.solDesMotivo
          }&NombrePos=${items.nombre.slice(9, items.nombre.length)}`
        )
        .then((r) => {
          console.log(r.data);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "¡Se Realizó los Cambios!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    mandarCorreo(usuCodigo, usuCorreo, nombre, postulante) {
      console.log(
        usuCodigo,
        usuCorreo,
        this.numeroDocumento,
        nombre,
        postulante
      );

      let parametro = localStorage.getItem("solicitudXpostulante");

      this.axios
        .get("SolicitudPostulante/ObtenerPosxSol/" + parametro)
        .then((r) => {
          this.informacion = r.data;

          for (let index of this.informacion) {
            if (index.idSolxPostulante == postulante) {
              this.axios
                .post(
                  `Values/CorreoPostulante?correoUsuario=${index.posCorreo
                  }&usuCodigo=${index.nombre.slice(
                    index.nombre.length - 8,
                    index.nombre.length - 1
                  )}&Contrase%C3%B1a=${this.numeroDocumento
                  }&Nombre=${index.nombre.slice(0, index.nombre.length - 9)}`
                )
                .then((r) => {
                  console.log(r.data);
                });
            }
          }
        });

      // this.info = response.data;
      //       this.axios
      //         .post(
      //           `Values/CorreoPostulante?correoUsuario=${usuCorreo}&usuCodigo=${usuCodigo}&Contrase%C3%B1a=${this.numeroDocumento}&Nombre=${nombre}`
      //         )
      //         .then((r) => {
      //           console.log(r.data);
      //         });
    },

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      this.dni_busqueda.length < 3 ? (this.adams = false) : (this.adams = true);

      return (
        items.nombre
          .toLocaleLowerCase()
          .indexOf(this.dni_busqueda.toLocaleLowerCase()) >= 0
      );
    },

    CrearUser(postulante, codigo, numeroDocumento, idSolxPostulante) {
      this.acomodar = postulante;
      let idPostulante = postulante;
      this.codigoUser = codigo;
      this.numeroDocumento = numeroDocumento;

      const user = {
        idPostulante,
      };
      console.log(user);
      this.getAttributes();
      this.axios.post("UsuarioPostulante/Registrar", user).then((respuesta) => {
        if (respuesta.data == true) {
          console.log(respuesta);
          for (let index of this.informacion) {
            if (index.idSolxPostulante == idSolxPostulante) {
              this.mandarCorreo(
                index.nombre.slice(
                  index.nombre.length - 8,
                  index.nombre.length - 1
                ),
                index.posCorreo,
                index.nombre.slice(0, index.nombre.length - 9),
                postulante
              );
            }
          }
          // console.log()
        }
      });
    },

    cambiarReferido(idSolxPostulante) {
      this.axios
        .put("SolicitudPostulante/ModificarSolReferido", { idSolxPostulante })
        .then((r) => {
          console.log(r.data);
          this.getAttributes();
        });
    },

    comenta(event, idSolxPostulante, solPosMotivos, solComentario) {
      console.log(event.target.value);
      this.comentarioCorrela = event.target.value;
      this.mandarComentarios(idSolxPostulante, solPosMotivos, solComentario);
    },

    mandarComentarios(idSolxPostulante, solPosMotivos, solComentario) {
      this.idPostulante = idSolxPostulante

      if (this.comentarioCorrela.length != "") {
        let solPosMotivo = this.comentarioCorrela;
        let idUsuario = this.forms.idUsuario;
        const form = {
          idSolxPostulante,
          solPosMotivo,
          solComentario,
          idUsuario,
        };

        console.log(form);

        this.axios
          .put("SolicitudPostulante/ModificarSolxPosEstado", form)
          .then((r) => {
            console.log(r.data);
            if (r.data == true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡Se Realizó los Cambios!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.insertarComentario = "";

              this.getAttributes();
              this.CargaObservaciones();
            }
          });
        console.log("se aplico el prier if");
      } else {
        let solPosMotivo = solPosMotivos;
        let idUsuario = this.forms.idUsuario;

        const form = {
          idSolxPostulante,
          solPosMotivo,
          solComentario,
          idUsuario,
        };

        console.log("se aplico el segundo if");

        this.axios
          .put("SolicitudPostulante/ModificarSolxPosEstado", form)
          .then((r) => {
            console.log(r.data);
            if (r.data == true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡Se Realizó los Cambios!",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.insertarComentario = "";

            this.getAttributes();
            this.CargaObservaciones();
          });
      }
    },

    datosIni(post) {
      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: post.fecIniContrato,
        fecFinContratos: "1900-01-01",
      };

      this.axios
        .put("SolicitudPostulante/ModificarFecContrato", from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "¡Cambio de fecha Inicio Realizado!",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        });
    },

    datosFin(post) {
      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: "1900-01-01",
        fecFinContratos: post.fecFinContrato,
      };

      this.axios
        .put("SolicitudPostulante/ModificarFecContrato", from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "¡Cambio de fecha fin Realizado!",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        });
    },


    editSeleccion(id) {
      this.$router.push("/EditadoSeleccion/" + id);
      window.scroll(0, 0);
    },

    editEntrevista(id) {
      this.$router.push("/datosEntrevista/" + id);
      window.scroll(0, 0);
    },
    editDocumentos(id) {
      this.$router.push("/datosDocmuentos/" + id);
      window.scroll(0, 0);
    },
    editCapacitaciones(id) {
      this.$router.push("/datosCapacitaciones/" + id);
      window.scroll(0, 0);
    },

    editContrato(id) {
      this.$router.push("/selectContrato/" + id);
      localStorage.setItem('BotonNever' , false)
    },

    EnviarCorreoNuevamente() {
      this.acomodar = "";
    },

    retroceso() {
      if (this.NUM_RESULTS === 4) {
        this.retro = false;
      } else {
        this.retro == true;
        this.NUM_RESULTS -= 4;
        this.pag -= 1;
      }
    },
    aumentar() {
      this.NUM_RESULTS += 4;
      this.pag += 1;
      if (this.NUM_RESULTS >= 4) {
        this.retro = true;
      } else {
        this.retro = false;
      }
      if (this.NUM_RESULTS > this.info.length) {
        this.avanzar = false;
      }
      // console.log(this.NUM_RESULTS);
    },

    ModificarTrabajador(event) {
      this.mandarPut.idSelAsignado = event.target.value;
      this.negado2 = false;
      for (let i of this.responsable) {
        if (i.idTrabajador == event.target.value) {
          this.nombreDelUsuario = i.nombreTrabajador;
        }
      }
    },

    getAttributesPut() {
      console.log(this.mandarPut);
      this.axios
        .put("TrabSeleccion/ModificarTrabSeleccion", this.mandarPut)
        .then((r) => {
          console.log(r.data);
          if (r.data == true) {
            this.getAttributs();
            Swal.fire({
              icon: "success",
              title: ` Responsable ${this.nombreDelUsuario}`,
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
    },

    ModificarEstado(event) {
      this.codSolEstado = event.target.value;
      console.log(this.codSolEstado);
      this.negado = false;

      //solo el recahzo el 4
      //combito de chebox marcados nomas apreces
    },

    getAttributesEstado() {
      let idSolicitud = this.mandarPut.idSolicitud;
      let codSolEstado = this.codSolEstado;
      let idUsuario = localStorage.getItem('userId')

      let json = {
        idSolicitud,
        codSolEstado,
        idUsuario
      };
      this.axios.put("TrabSeleccion/ModificarEstadoSol", json).then((r) => {
        if (r.data) {
          Swal.fire({
            icon: "error",
            title: "Se rechazó el RQ",
            footer: "<strong>Gracias....</>",
          });
        }
      });
    },

    editarDatoSolicitud() {
      this.$router.push("/datosSolicitud/" + this.$route.params.postulante);
      window.scroll(0, 0);
    },

    // base() {
    //   // console.log(this.parametro)
    //   this.$router.push("/registroGestionSolicitud/" + this.parametro);
    // },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 1.2rem;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamaño {
  font-size: 0.65rem;
}

input {
  font-size: 0.65rem;
}

.tabla {
  background: rgb(24, 147, 196);
}

.bg-solimano {
  background: #0080c8;
}

.agrandar {
  width: 280px;
  /* height: 10px; */
}

.tamañoLetra {
  font-family: sans-serif;
  font-size: 0.65rem;
}

.pintar {
  font-weight: 700;
  color: #002c5d;
}

.tamañoCuadro {
  font-size: 0.65rem;
}

.letrasTitulos {
  color: #52658c;
}

.selector {
  width: 500px;
}

#modal-center5 .modal-dialog {
  min-height: 300px;
  /* Ajusta el valor según tus necesidades */
}

.btn-solimano {
  background: #0080c8;
}
</style>
